import { Component } from '@angular/core';
import { SnackService } from '../../service/snack.service';

@Component({
    selector: 'rr-snackbar',
    standalone: false,

    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent {

    private _showSnackbar = false;

    get showSnackbar(): boolean {
        return this._showSnackbar;
    }

    set showSnackbar(value: boolean) {
        this._showSnackbar = value;
        this.onShowSnackbarChange(value);
    }

    snakbarContent = '';
    snackbarHeadline = '';
    type = '';
    iconName = 'info';

    constructor(
        private snack: SnackService,
    ) {
        snack.snackText.subscribe((text: string) => {
            this.snakbarContent = text;
        });
        snack.snackHeadline.subscribe((headline: string) => {
            this.snackbarHeadline = headline;
        });
        snack.showSnack.subscribe((show: boolean) => {
            this.showSnackbar = show;
        });
        snack.type.subscribe((type) => {
            this.type = type;
            if (type === 'error') this.iconName = 'octagon'
            if (type === 'success') this.iconName = 'check_circle';
            if (type === 'warning') this.iconName = 'alert';

        });
    }

    onShowSnackbarChange(value: boolean) {
        if (this.type !== 'error' && value === true) {
            if (value === true) {
                setTimeout(() => {
                    this.showSnackbar = false;
                }, 5000);
            }
        }
    }

    close() {
        this.showSnackbar = false;
    }
}
